import { InfoCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import { Input, InputNumber, Tooltip } from "antd";
import { IFormInputProps } from "./IFormComponents";

const FormInput = (props: IFormInputProps) => {
  const {
    mandatory,
    field,
    onChangeInvestor,
    label,
    value,
    placeholder = "Complete el campo",
    numeric,
    disabled = false,
    error,
    isOcrLoading,
	translations,
	tooltip,
  } = props;

  const handleChange = (val: any) => {
	const value = numeric ? val : val.target.value;
    onChangeInvestor(value, field);
  };

  return (
    <div className="investor-form-item">
      <label
        className={`${mandatory ? "mandatory" : ""} ${
          error ? "error-input" : ""
        } `}
      >
		{label}
		{tooltip && (
			<Tooltip
				title={tooltip}
				placement="right"
			>
				{" "}<InfoCircleOutlined style={{ color: "#6b6b6bff" }} />
			</Tooltip>
		)}
      </label>
      {numeric ? (
        <InputNumber
          value={value}
          placeholder={isOcrLoading ? translations?.readingDocument : placeholder}
          onChange={handleChange}
          style={{ width: "100%" }}
          disabled={disabled || isOcrLoading}
          status={error ? "error" : undefined}
        />
      ) : (
        <Input
          value={value}
		  placeholder={isOcrLoading ? translations?.readingDocument : placeholder}
          onChange={handleChange}
          disabled={disabled || isOcrLoading}
          status={error ? "error" : undefined}
          onBlur={() => value && onChangeInvestor(value.trim(), field)}
          suffix={isOcrLoading ? <LoadingOutlined spin /> : null}
        />
      )}
    </div>
  );
};

export default FormInput;
